import React from "react"
import FormGroup from "../../../Form/FormGroup"
import Textarea from "../../../Form/Textarea"
import BreakForm from './../../../Form/BreakForm/index';

const AiResponse = ({ data = {}, onChange = () => { } }) => {
    const handleChangeContent = (name, value) => {
        onChange(name, value)
    }

    return (
        <FormGroup>
            <BreakForm title="Instruções" showAction={false} border={false} />
            <FormGroup labelText="Instruções para a IA gerar a mensagem">
                <Textarea
                    placeholder="Ex: Pergunte o nome do lead."
                    onChange={(e) => handleChangeContent("prompt", e.target.value)}
                    value={data?.prompt || ""}
                    rows={10}
                />
            </FormGroup>
            <FormGroup labelText="Quando a IA pode seguir para o próximo passo?">
                <Textarea
                    placeholder="Ex: Quando o usuário informar claramente o que deseja."
                    onChange={(e) => handleChangeContent("expected_response", e.target.value)}
                    value={data?.expected_response || ""}
                    rows={10}
                />
            </FormGroup>
            {/* <FormGroup labelText="Número máximo de tentativas antes de parar">
                <Input
                    type="number"
                    min={1}
                    max={5}
                    onChange={(e) => handleChangeContent("max_attempts", Number(e.target.value))}
                    value={data?.max_attempts || 3}
                />
            </FormGroup>
            <BreakForm title="Reengajamento" showAction={false} border={false} />
            <FormGroup labelText="Enviar mensagem de reengajamento?">
                <Select
                    name="Enviar mensagem de reengajamento?"
                    placeholder="Selecione uma opção..."
                    options={optionsBoolean}
                    selected={Number(data.send_followup_message ?? "")}
                    onChange={(value) => handleChangeContent("send_followup_message", Number(value))}
                    multiple={false}
                />
            </FormGroup>
            {Boolean(data?.send_followup_message) && <>
                <FormGroup labelText="Tempo de espera antes de enviar mensagem de reengajamento (em minutos)">
                    <Input
                        type="number"
                        min={1}
                        placeholder="Ex: 10"
                        onChange={(e) => handleChangeContent("followup_wait_time", Number(e.target.value))}
                        value={data?.followup_wait_time || ""}
                    />
                </FormGroup>
                <FormGroup labelText="Mensagem de reengajamento">
                    <Textarea
                        placeholder="Ex: Ainda está aí? Estou disponível para ajudar com qualquer dúvida!"
                        onChange={(e) => handleChangeContent("followup_message", e.target.value)}
                        value={data?.followup_message || ""}
                        rows={4}
                    />
                </FormGroup>
            </>} */}
        </FormGroup>
    )
}

export default AiResponse
